export default {
  title: "Workspaces",
  title_chart_area: "Total open Issues - Trendlines",
  title_chart_treemap: "Issue priority distribution",
  treemap_raised: "Raised",
  treemap_work_order: "In Work Order",
  treemap_corrected: "Corrected",
  treemap_total: "In Total",
  tab_overview: "Overview",
  tab_issue: "Issue analytics",
  tab_work_domain: "Work Domains",
  tab_you: "You",
  work_domains_title: "Work Domains and you",
  workspace_home: "Workspace Home",
  table_column_overview_label: "Overview",
  table_column_organisation_label: "Organisation",
  table_column_group_label: "Group",
  table_column_items_label: "Items (#)",
  table_column_areas_label: "Areas (#)",
  table_column_issues_label: "Issues (#)",
  table_column_work_orders_label: "Work Orders (#)",
  table_column_ws_health_label: "Workspace Health",

  // Workspace Overview
  workspace_info_title: "Workspace information",
  assignments_title: "Assignments and unassessed Issues",
  work_title: "Work and Work Orders",
  change_requests_title: "Change requests",
  designation_label: "Designation",
  organisation_label: "Organisation",
  items_label: "Items",
  areas_label: "Areas",
  layouts_label: "Layouts",
  locations_label: "Locations",
  models_label: "Models",
  zones_label: "Zones",
  admins_label: "Administrators",
  notes_label: "Notes",
  assignments_label: "Assignments",
  issues_label: "Open Issues",
  corrective_work_label: "Unassessed Corrective Work",
  regular_work_label: "Unassessed Regular Work",
  overdue_work_label: "Overdue Work Orders",
  obstructed_work_label: "Obstructed Work",
  data_changes_label: "Data changes",
  location_changes_label: "Location changes",
  file_changes_label: "File changes",
  work_orders_title: "Work and Work Orders",
  work_orders_assigned_label: "Assignments",
  work_orders_label: "Open Work Orders",
  // The bar needs special escaping, because is used for pluralization in vue-i18n.
  performed_work_label: "Unassessed Performed Work (Corrective {'|'} Regular)",
}
